import { useForm } from "react-hook-form";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import { RefreshCcw } from "lucide-react";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import UpdateAdminsRolesSuccessDialog from "../dialogs/UpdateAdminsRolesSuccessDialog";

const UpdateAdminsForm = ({
  userData,
  userSetup,
  sendData,
  loading,
  successResponse,
}) => {
  const { id, fullName, jbccSupervisor, jnSupervisor, jbccAdmin, jnAdmin } =
    userData;
  const { handleSubmit, watch, setValue, control, reset } = useForm({
    defaultValues: {
      jbccSupervisorId: jbccSupervisor.id,
      jnSupervisorId: jnSupervisor.id,
      jbccAdminId: jbccAdmin.id,
      jnAdminId: jnAdmin.id,
    },
  });

  const { jbccSupervisorId, jbccAdminId, jnSupervisorId, jnAdminId } = watch();

  const onSubmit = (data) => {
    const confirmData = { userId: id, ...data };
    sendData(confirmData, reset);
  };
  return (
    <div className="form-container">
      <CenteredHeading title="Update Admins" />
      <div className="formDetails">
        <p>
          <strong>User Name</strong> : {fullName}
        </p>
        <p>
          <strong>User Id</strong> : {id}
        </p>
      </div>
      <form
        className="form-border max-w-5xl mx-auto"
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
      >
        <div className="grid grid-cols-2 gap-2">
          <SearchDropdown
            name="jbccSupervisorId"
            label="Supervisor (JBCC) *"
            keyName="fullName"
            id="id"
            options={userSetup.jbcc_supervisors}
            control={control}
            setValue={setValue}
            selectedVal={jbccSupervisorId}
            disableValidationMessage={true}
          />
          <SearchDropdown
            name="jnSupervisorId"
            label="Supervisor (Jal Nirikshan) *"
            keyName="fullName"
            id="id"
            options={userSetup.jn_supervisors}
            control={control}
            setValue={setValue}
            selectedVal={jnSupervisorId}
            disableValidationMessage={true}
          />
          <SearchDropdown
            name="jbccAdminId"
            label="Admin (JBCC) *"
            keyName="fullName"
            id="id"
            options={userSetup.jbcc_admins}
            control={control}
            setValue={setValue}
            selectedVal={jbccAdminId}
            disableValidationMessage={true}
          />
          <SearchDropdown
            name="jnAdminId"
            label="Admin (Jal Nirikshan) *"
            keyName="fullName"
            id="id"
            options={userSetup.jn_admins}
            control={control}
            setValue={setValue}
            selectedVal={jnAdminId}
            disableValidationMessage={true}
          />
        </div>
        <div className="submitWrap">
          <p className="addWrap">
            <PrimaryButton
              btnText={!loading ? "Update Admins" : "Adding..."}
              loading={loading}
              Icon={RefreshCcw}
              size={18}
            />
          </p>
          <p className="grayWrap">
            <GrayButton btnText="Reset" width="w-40" onClick={() => reset()} />
          </p>
        </div>
      </form>
      {successResponse && (
        <UpdateAdminsRolesSuccessDialog msg="User Admins Successfully updated" />
      )}
    </div>
  );
};
export default UpdateAdminsForm;
